<template>
  <router-view></router-view>
  <Toaster />
</template>

<script setup>
import { Toaster } from "@/components/ui/toast";
import { inject } from "vue";

// Do Login on F5-Refresh
const store = inject("store");
store.authModule.actions.userAutoLogin();
</script>

<style>
@import "~bootstrap/dist/css/bootstrap.min.css";
@import "~bootstrap-vue-3/dist/bootstrap-vue-3.css";
@import "~@fortawesome/fontawesome-free/css/all.min.css";
@import "~animate.css/animate.min.css";
@import "@/assets/brand.css";

.bgGrey {
  background-color: #f5f5f5;
}

.mx-datepicker-sidebar {
  width: 125px !important;
}

.bg-menuLeft {
  background: #ffffff !important;
  background: linear-gradient(
    180deg,
    rgba(255, 111, 96, 0.2) 10%,
    rgba(111, 89, 253, 0.3) 100%
  ) !important;
}
.bg-menuTop {
  background: #ffffff !important;
  background: linear-gradient(
    90deg,
    rgba(255, 111, 96, 0.2) 10%,
    rgba(111, 89, 253, 0.2) 100%
  ) !important;
}
</style>
